'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _card = require('./card.css');
var _card2 = _interopRequireDefault(_card);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Card = function (_Component) {
  _inherits(Card, _Component);
  function Card() {
    _classCallCheck(this, Card);
    return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }
  _createClass(Card, [{
    key: 'render',
    value: function render() {
      var suitMap = {
        'S': 'Spades',
        'H': 'Hearts',
        'C': 'Clubs',
        'D': 'Diamonds'
      };
      var rankMap = {
        'A': 'Ace',
        '2': 'Deuce',
        '3': 'Three',
        '4': 'Four',
        '5': 'Five',
        '6': 'Six',
        '7': 'Seven',
        '8': 'Eight',
        '9': 'Nine',
        'T': 'Ten',
        'J': 'Jack',
        'Q': 'Queen',
        'K': 'King'
      };
      return _react2.default.createElement('div', {
        className: 'wrapper'
      }, _react2.default.createElement('div', {
        className: 'card'
      }, _react2.default.createElement('div', {
        className: this.props.suit + ' mark dark'
      }, this.props.rank), _react2.default.createElement('div', {
        className: 'content '
      }, _react2.default.createElement('h1', null, rankMap[this.props.rank]), _react2.default.createElement('h2', null, _react2.default.createElement('sup', null, 'OF'), _react2.default.createElement('span', {
        className: 'dark'
      }, suitMap[this.props.suit]))), _react2.default.createElement('div', {
        className: this.props.suit + ' mark upside-down'
      }, this.props.rank)));
    }
  }]);
  return Card;
}(_react.Component);
exports.default = Card;
"use strict";